import React from 'react'
import type { IOccurrencesAssociatedDrugs, ResponseProps } from '../interfaces'
import { createState, useState, type State } from '@hookstate/core'
import {
  getOccurrencesAssociatedDrugByType,
  getOccurrencesAssociatedDrugByCircumstance,
  getOccurrencesAssociatedDrugByDestination,
  getOccurrencesAssociatedDrugByOccurrenceType,
} from '../components/QualifiersCharts/DrugsChart/services'

interface IOccurrencesAssociatedDrugsProps {
  readonly occurrencesAssociatedDrugs: IOccurrencesAssociatedDrugs
  readonly loadingCharts: boolean
}

const occurrencesAssociatedDrugsProps: Readonly<ResponseProps> = {
  item: null,
  value: null,
  total: null,
}

const occurrencesAssociatedDrugsDefault: Readonly<IOccurrencesAssociatedDrugs> = {
  occurrencesAssociatedDrugByType: occurrencesAssociatedDrugsProps,
  occurrencesAssociatedDrugByCircumstance: occurrencesAssociatedDrugsProps,
  occurrencesAssociatedDrugByDestination: occurrencesAssociatedDrugsProps,
  occurrencesAssociatedDrugByOccurrenceType: occurrencesAssociatedDrugsProps,
}

const store = createState<Readonly<IOccurrencesAssociatedDrugsProps>>({
  occurrencesAssociatedDrugs: occurrencesAssociatedDrugsDefault,
  loadingCharts: true,
})

interface getAllsAssociatedDrugsDataProps {
  readonly startDate: string | null
  readonly finishDate: string | null
  readonly drugTypeId: number | null
  readonly destinationId: number | null
  readonly circunstanceId: number | null
}

export default function useManagementQualifiersDrugsState() {
  const occurrencesAssociatedDrugs: State<
    Readonly<IOccurrencesAssociatedDrugs>
  > = useState(store.occurrencesAssociatedDrugs)
  const loadingCharts = useState(store.loadingCharts)

  async function getAssociatedDrugsStats({
    startDate,
    finishDate,
    drugTypeId,
    destinationId,
    circunstanceId,
  }: getAllsAssociatedDrugsDataProps) {
    const params = {
      startDate,
      finishDate,
      drugTypeId,
      destinationId,
      circumstanceId: circunstanceId, // ajuste o nome do parâmetro
    }

    loadingCharts.set(true)

    Promise.all([
      getOccurrencesAssociatedDrugByType(params).then((response) => {
        occurrencesAssociatedDrugs.occurrencesAssociatedDrugByType.set(
          response
        )
      }),
      getOccurrencesAssociatedDrugByCircumstance(params).then((response) => {
        occurrencesAssociatedDrugs.occurrencesAssociatedDrugByCircumstance.set(
          response
        )
      }),
      getOccurrencesAssociatedDrugByDestination(params).then((response) => {
        occurrencesAssociatedDrugs.occurrencesAssociatedDrugByDestination.set(
          response
        )
      }),
      getOccurrencesAssociatedDrugByOccurrenceType(params).then((response) => {
        occurrencesAssociatedDrugs.occurrencesAssociatedDrugByOccurrenceType.set(
          response
        )
      }),
      // Não há funções para Brand e State, remova ou ajuste conforme necessário
    ]).finally(() => {
      loadingCharts.set(false)
    })
  }

  return {
    occurrencesAssociatedDrugs: () => occurrencesAssociatedDrugs,
    fetchAllAssociatedDrugsData: async ({
      destinationId,
      finishDate,
      drugTypeId,
      circunstanceId,
      startDate,
    }) =>
      getAssociatedDrugsStats({
        destinationId,
        finishDate,
        drugTypeId,
        circunstanceId,
        startDate,
      }),
    loadingCharts: loadingCharts,
  }
}
